import { useState, useEffect } from "react";
import axios from "axios";
import { getItem, getLoginToken } from '../../../utils/storageUtils'
import { toast } from "../../../components/Toast";
import { getApkStart } from "../../../store/redux-slices/uploadApk";
import { useDispatch, useSelector } from "react-redux";
import { use } from "react";




export default function useUploadApk() {
    const { REACT_APP_API_URL } = process.env;

    const { isLoadingGetApk, apkListing, } = useSelector(
        (state) => state.uploadApk
    );
    const dispatch = useDispatch()


    const [loading, setLoading] = useState(false);
    const [isAddApkLoading, setIsAddApkLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [data, setData] = useState(null);

    useEffect(() => {
        dispatch(
            getApkStart({

            })
        );
    }, []);

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("apkFile", file);

        setIsAddApkLoading(true);
        setProgress(0);

        try {
            const res = await axios.post(`${REACT_APP_API_URL}/api/admin/android-apk`, formData, {
                headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${getLoginToken()}` },
                onUploadProgress: (event) => {
                    if (event.total) {
                        const percent = Math.round((event.loaded * 100) / event.total);
                        setProgress(percent);
                    }
                },
            });
            toast("Apk uploaded successfully", "success");
            setData(res.data);
            dispatch(
                getApkStart({

                })
            );

        } catch (err) {
            toast("Error while uploading apk", "error");
            console.error(err);
        } finally {
            setIsAddApkLoading(false);
            setProgress(0); // reset after upload finishes
        }
    };

    return { loading, data, handleFileChange, isAddApkLoading, progress, isLoadingGetApk, apkListing };
}
